
import { Vue } from "vue-class-component";

export default class PlusO extends Vue {}
